import { Component, OnInit } from '@angular/core';
import { Navigator } from '../../menu/navigator';
import { LevelService } from 'src/app/services/lobby/level.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { CustomerModel } from 'src/app/models/customer-model';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { AudioService } from 'src/app/services/audio/audio.service';
import { isUndefined } from 'src/app/services/codeUtils';
import { take } from 'rxjs/operators';
import { Platform } from '@ionic/angular';
@Component({
  selector: 'app-footer-leader-board',
  templateUrl: './footer-leader-board.component.html',
  styleUrls: ['./footer-leader-board.component.scss'],
})
export class FooterLeaderBoardComponent implements OnInit {
  isCustomerAllowedLeaderboard: boolean = false;
  public unlockLevel: any = this.config.getConfig().LEADERBOARD_LOYALTY_REQUIRED_LEVEL;
  tutorialAvailable: string = "false";
  private tl: GSAPTimeline;
  lbEnabled: boolean;
  customer: CustomerModel;
  public leaderboardImage: string;
  public isIOSMobile:boolean = false;

  constructor(
    private readonly navigator: Navigator,
    private levelService:LevelService,
    private config:ConfigService,
    private userSession:UserSessionService,
    private audioService: AudioService,
    private platform: Platform

  ) {
    this.isIOSMobile =  this.platform.is('ios') && this.platform.is('mobile');
    this.lbEnabled = this.config.getConfig().SHOW_LB_LOBBY === "1" ? true : false;
    this.levelService.level$.subscribe(res => {
      this.isCustomerAllowedLeaderboard = this.levelService.checkLeaderBoardAvailable();

      this.leaderboardImage = this.isCustomerAllowedLeaderboard ? 'imgs/button_leaderboard.png' : 'imgs/button_leaderboard_dark.png';
      this.userSession.getCustomer().pipe(take(2)).subscribe(
        (customer: CustomerModel) => {
          if (customer) {
            this.customer = customer;
            this.userSession.isAuthenticated().then(isAuth => {
              if(isAuth){
                if (null !== customer.getCustomDataProperty('LB_TUTORIAL_VIEWED')) {
                  this.tutorialAvailable = customer.getCustomDataProperty('LB_TUTORIAL_VIEWED');
                }else {
                   // Setting tutorials to view true for migrated players
                  //  if(!!res){
                    // if(res >= Number(this.config.getConfig().LEADERBOARD_LOYALTY_REQUIRED_LEVEL)){
                    //   this.levelService.setTutorial('LB_TUTORIAL_VIEWED',"true");
                    // }
                    // else {
                    //   this.levelService.setTutorial('LB_TUTORIAL_VIEWED',"false");
                    // }
                  //  }
                }
              }
            })
          }
        });
    })
   }


  ngOnInit() {
    
  }

  protected openLeaderboard(){
    this.userSession.getCustomer().subscribe(
      (customer: CustomerModel) => {
      if (customer) {
        this.customer = customer;
        this.userSession.isAuthenticated().then(isAuth => {
          if(isAuth){
            if (null !== customer.getCustomDataProperty('LB_TUTORIAL_VIEWED')) {
              this.tutorialAvailable = customer.getCustomDataProperty('LB_TUTORIAL_VIEWED');
            }
          }
        })
      }
    });
    if(this.isCustomerAllowedLeaderboard){
      if(this.customer.nickName === null || isUndefined(this.customer.nickName)) {
        this.navigator.navigateTo('LeaderboardCongratsPopupComponent',{ customModalClass: 'custom-piggy-model-class-transparent', backdropDismiss: true })
      }else {
        this.audioService.playSound("LeaderboardOpen");
        return this.navigator.navigateTo('LeaderboardComponent', { customModalClass: 'custom-piggy-model-class-transparent', backdropDismiss: true });
      }
    }
  }
}
